import { render, staticRenderFns } from "./modalCntn.vue?vue&type=template&id=22cc0bfe&"
import script from "./modalCntn.vue?vue&type=script&lang=js&"
export * from "./modalCntn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports